// Angular
import {
	Component,
	ComponentFactoryResolver,
	ComponentRef,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
// Model
import { LayoutRenderLayoutItem } from '../../../models/cv-layout-render.model';

@Component({
	selector: 'cv-schema-render-component',
	templateUrl: './dynamic-component.component.html'
})
export class DynamicComponentComponent implements OnInit, OnChanges {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();

	@ViewChild('componentContainer', { read: ViewContainerRef, static: true })
	componentContainer: ViewContainerRef;

	newComponent: ComponentRef<any> = null;

	constructor(private componentFactory: ComponentFactoryResolver) {
		//
	}

	/**
	 * Create the Component at the beginning
	 */
	ngOnInit(): void {
		this.createComponent();
	}

	/**
	 * Wait for any change to the Model
	 */
	ngOnChanges(changes: SimpleChanges): void {
		this.updateComponentV1(changes);
		this.updateComponentV2();
	}

	/**
	 * Create Component
	 */
	public createComponent(): void {
		if (this.componentContainer && this.newComponent === null && this.layoutNode) {
			if (this.layoutNode.permissionToRender) {
				this.newComponent = this.componentContainer.createComponent(
					this.componentFactory.resolveComponentFactory(this.layoutNode.widget)
				);

				if (this.newComponent && this.newComponent !== null) {
					this.newComponent.instance['data'] = this.data;
					this.newComponent.instance['layoutNode'] = this.layoutNode;
				}
			}
		}
	}

	/**
	 * Update Component with NgOnChanges
	 */
	private updateComponentV1(changes: SimpleChanges): void {
		if (this.newComponent && this.newComponent !== null && 'ngOnChanges' in this.newComponent.instance) {
			this.newComponent.instance.ngOnChanges(changes);
		}
	}

	/**
	 * Update Component by Calling a Function interface
	 * Dynamic Components do not handle properly NgOnChanges
	 */
	private updateComponentV2(): void {
		if (this.newComponent && this.newComponent !== null) {
			if (this.newComponent.instance.reloadData && this.newComponent.instance.markForCheck) {
				this.newComponent.instance.markForCheck = false;
				this.newComponent.instance.reloadData({ data: this.data, layoutNode: this.layoutNode });
			}
		}
	}

}
